module.exports = __webpack_public_path__ + "media/A_level2_loop.23c9ede7.mp3";